import React from "react";

type ArrowRightIconProps = {
  color?: string;
};

const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({ color = "#000" }) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4243 11.1931C16.8765 11.6394 16.8765 12.3642 16.4243 12.8104L9.47805 19.6653C9.02582 20.1116 8.2914 20.1116 7.83917 19.6653C7.38694 19.219 7.38694 18.4943 7.83917 18.048L13.9678 12L7.84279 5.95202C7.39056 5.50575 7.39056 4.78099 7.84279 4.33471C8.29502 3.88843 9.02944 3.88843 9.48167 4.33471L16.4279 11.1896L16.4243 11.1931Z"
      fill={color}
    />
  </svg>
);

export default ArrowRightIcon;
